import { render } from "./vsetderivativeslog.vue?vue&type=template&id=687a331d&scoped=true"
import script from "./vsetderivativeslog.vue?vue&type=script&lang=js"
export * from "./vsetderivativeslog.vue?vue&type=script&lang=js"

import "./vsetderivativeslog.vue?vue&type=style&index=0&id=687a331d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687a331d"]])

export default __exports__